import React from 'react';
import { BaseOptionType } from '@tink/core/src/components/molecules/Select/SingleSelect';
import { ProviderField, SelectOption } from '../../../../../../../models/provider';
import { SelectField } from '../SelectField';

export type SelectProviderFieldOptionProps = {
  field: ProviderField & { selectOptions: SelectOption[] };
  value: string;
  onChange: (value: string) => void;
  errorMessage: string;
};

export const SelectProviderFieldOption = ({
  value,
  field: { name, description, selectOptions },
  onChange,
  errorMessage,
}: SelectProviderFieldOptionProps) => {
  const options: BaseOptionType<string>[] = selectOptions.map((option) => ({
    label: option.text,
    value: option.value,
  }));

  return (
    <SelectField
      name={name}
      value={value}
      description={description}
      options={options}
      onChange={(opt) => onChange(opt.currentTarget.value)}
      errorCaption={errorMessage}
    />
  );
};
